import * as actions from './actions'
import * as getters from './getters'

export default {
  namespaced: true,
  state: {
    authenticated: false,
    user: {
      company: {
        name: null,
        id: null
      },
      name: null
    }
  },
  mutations: {
    login (state, {company, name}) {
      state.user = {company, name}
      state.authenticated = true
    },
    logout (state) {
      state.user = {company: null, name: null}
      state.authenticated = false
    }
  },
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js